import * as React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { MessageBlock, Text } from 'DVWebNodeUI'
import { TextLocalizer } from '../localizer/localizer'
import { IDetailPageState } from '../../reducers'
import { clearBanner } from '../../actions/banner'

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

const TRANSITION_MS = 300

export const UiBannerConnected = ({ banner, clearBanner }: Props) => {
  if (!banner) {
    return null
  }
  const { stringId, string, type, heading } = banner
  return (
    <MessageBlock heading={heading || ''} type={type} dismissable onDismiss={clearBanner}>
      {stringId && <TextLocalizer stringID={stringId} />}
      {string && <Text string={string} />}
    </MessageBlock>
  )
}

const mapStateToProps = (state: IDetailPageState) => ({
  banner: state.banner.ui,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  clearBanner: () => setTimeout(() => dispatch(clearBanner()), TRANSITION_MS),
})

export const UiBanner = connect(
  mapStateToProps,
  mapDispatchToProps
)(UiBannerConnected)
